/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.dashboard.analysis.app_visit_rank.name': '应用名称',
  'pages.dashboard.analysis.app_visit_rank.count': '访问次数',
  'pages.dashboard.analysis.app_visit_rank.title': '应用访问排名（前十）',
  'pages.dashboard.analysis.authn_quantity.title': '认证量',
  'pages.dashboard.analysis.authn_policy_zone.title': '登录位置分布',
  'pages.dashboard.analysis.authn_policy_zone.tooltip.alias.name': '省份',
  'pages.dashboard.analysis.authn_policy_zone.tooltip.alias.count': '登录次数',
  'pages.dashboard.analysis.hot_authn_provider.title': '热门认证方式',
  'pages.dashboard.analysis.overview.today_auth.count': '今日认证量',
  'pages.dashboard.analysis.overview.auth_source.count': '认证源总数',
  'pages.dashboard.analysis.overview.user.count': '用户数量',
  'pages.dashboard.analysis.overview.app.count': '应用数量',
};
